/**
 * Read ?token= once and remove it from the address bar (history.replaceState).
 * Call synchronously before React mounts so Strict Mode / double effects don't
 * trigger a second token exchange.
 */
export function consumePlayerUrlToken(): string | null {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  if (!token?.trim()) return null;
  params.delete("token");
  const qs = params.toString();
  const path = window.location.pathname + (qs ? `?${qs}` : "") + window.location.hash;
  window.history.replaceState(null, "", path);
  return token.trim();
}
